import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import "./Header.scss";

import ZYXMedia from "./../Images/zyx-media.svg";

const menuItems = [
    { name: "Home", to: "/" },
    { name: "Portfolio", to: "/Portfolio" },
    { name: "Services", to: "/Services" },
    { name: "About Us", to: "/About-Us" },
]

export default function Header() {
    useEffect(() => {
        const handleScroll = () => {
            const header = document.getElementById('Header');
            if (window.scrollY > 30) {
                header.classList.add('fixed');
            } else {
                header.classList.remove('fixed');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleLogoClick = (e) => {
        if (location.pathname === '/') {
            e.preventDefault();
            window.location.reload();
        }
    };

    const handleContactClick = () => {
        window.dispatchEvent(new Event("scrollToForm"));
    };

    const location = useLocation();

    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener("resize", function (event) {
            setWidth(window.innerWidth);
        });
    });

    const sidebarTgl = () => {
        document.getElementById("sidebar").classList.toggle("active");
        document.getElementById("navbar-toggle").classList.toggle("active");
        document.body.classList.toggle("fix");
    };
    return (
        <header>
            <div id='Header' className='header'>
                <div className='container-fluid float-none'>
                    <div className='logo'><Link to="/" onClick={handleLogoClick}><img src={ZYXMedia} alt='ZYX Media' title='ZYX Media' width='500' height='91' /></Link></div>
                    <nav className='main-menu'>
                        <ul>
                            {menuItems.map((item, index) => {
                                const isActive = location.pathname === item.to;
                                return (
                                    <li key={index}><Link to={item.to} className={`nav-item ${isActive ? 'active' : ''}`}>{item.name}</Link></li>
                                )
                            })}
                            <li><Link className="glow-btn" onClick={handleContactClick}><span>Contact Us</span></Link></li>
                        </ul>
                    </nav>
                    {width <= 1080 && (<div id='navbar-toggle' className='navbar-toggle'><div onClick={sidebarTgl}><span></span></div></div>)}
                </div>
            </div>
        </header>
    )
}
